import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalWrapper = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
`;

export const ModalIcon = styled.div`
  margin-bottom: 16px;
  color: #F87171; // Vermelho para avisos
`;

export const ModalTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #303030;
  margin: 0 0 8px 0;
`;

export const ModalMessage = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #696969;
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const Button = styled.button<{ variant?: 'primary' | 'outline' | 'danger' | 'danger-outline' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;

  ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return `
          background-color: #0090D3;
          color: #FFFFFF;
          border-color: #0090D3;
        `;
      case 'danger':
        return `
          background-color: #F87171;
          color: #FFFFFF;
          border-color: #F87171;
        `;
      case 'danger-outline':
        return `
          background-color: #FFFFFF;
          color: #F87171;
          border-color: #F87171;
        `;
      case 'outline':
      default:
        return `
          background-color: #FFFFFF;
          color: #0090D3;
          border-color: #0090D3;
        `;
    }
  }}
`;
